import React, { useMemo } from 'react';

import { Box } from '@atlaskit/primitives/compiled';
import ReactRenderer from '@atlaskit/renderer/renderer';
import { encodeAdf } from '@atlassian/conversation-assistant-content-transformer/adf-encoder';

import type { MarkdownElement } from '../../dynamic-layout-parser/types/dynamic-layout-section';

export const DynamicLayoutMarkdown = ({
	component,
}: {
	component: MarkdownElement;
}): React.JSX.Element | null => {
	const markdown = component.children?.[0] as string;

	const docContent = useMemo(() => (markdown ? encodeAdf(markdown, false) : undefined), [markdown]);
	return docContent ? (
		<Box testId="dynamic-layout-markdown">
			<ReactRenderer document={docContent} />
		</Box>
	) : null;
};
